/**
 * See if an order parameter is specifying an ascending sort.
 * @param orderBy Ordering parameter from a URL.
 * @returns       True if the parameter is sorting in ascending direction.
 *
 * @example
 * // Returns true:
 * isOrderedByAscending("property", "property.asc")
 *
 * // Returns false:
 * isOrderedByAscending("property", "property.desc")
 */
export const isOrderedByAscending = (property: string, orderBy?: string) => {
    return typeof orderBy === "string" && /([a-z_])+.asc/i.test(orderBy.trim());
};
